import { ReactComponent as Close } from "../assets/svg/close.svg";
import { ReactComponent as PointerLeft } from "../assets/svg/pointer-left.svg";
import { ReactComponent as PointerRight } from "../assets/svg/pointer-right.svg";
import { ReactComponent as PointerSmallLeft } from "../assets/svg/pointer-small-left.svg";
import { ReactComponent as PointerSmallRight } from "../assets/svg/pointer-small-right.svg";
import { ReactComponent as GlascLogo } from "../assets/svg/glasc-logo.svg";
import { ReactComponent as GlascBug1 } from "../assets/svg/glasc-bug-1.svg";
import { ReactComponent as GlascBug2 } from "../assets/svg/glasc-bug-2.svg";
import { ReactComponent as Menu } from "../assets/svg/menu.svg";

export const icons = {
  Close,
  PointerLeft,
  PointerRight,
  PointerSmallLeft,
  PointerSmallRight,
  GlascLogo,
  GlascBug1,
  GlascBug2,
  Menu,
};
